const $ = require('jquery/dist/jquery');
const Bloodhound = require('corejs-typeahead/dist/bloodhound');
const providerPrototype = require('./prototpye');
const autocompleteLiterals = require('../../../../../literals/autocomplete/prototype');

const borgTypes = {
    bus: {
        code: 'BUS',
        icon: '.bus-icon',
        literal: 'bus'
    },
    city: {
        code: 'CIU',
        icon: '.cities-icon',
        literal: 'cities'
    },
    airport: {
        code: 'AER',
        icon: '.airport-icon',
        literal: 'airports'
    },
    hotel: {
        code: 'HOT',
        icon: '.hotel-icon',
        literal: 'hotels'
    },
    pdi: {
        code: 'PDI',
        icon: '.marker-icon',
        literal: 'pdi'
    },
    port: {
        code: 'PUE',
        icon: '.ferry-icon',
        literal: 'ports'
    },
    island: {
        code: 'ISL',
        icon: '.islands-icon',
        literal: 'islands'
    },
    zone: {
        code: 'ZON',
        icon: '.marker-icon',
        literal: 'zones'
    },
    station: {
        code: 'EST',
        icon: '.train-icon',
        literal: 'stations'
    },
    flightCompany: {
        code: 'FLIGHTS_COMPANY',
        icon: '.airport-icon',
        literal: 'flightCompanies'
    }
};

const transform = (response, dataset, groupKey) => {
    if (response && response.d) {
        if (groupKey) {
            return response.d
                .filter(item => (item && item.type === groupKey ? item : false))
                .map(element => ({
                    [dataset.displayKey]: $(`<p>${element[dataset.displayValue]}</p>`).text(),
                    ...element
                }));
        }

        return response.d
            .filter(item => item)
            .map(element => ({
                [dataset.displayKey]: $(`<p>${element[dataset.displayValue]}</p>`).text(),
                ...element
            }));
    }
    return [];
};

const configureParameters = (language, parameters, types) => {
    const params = parameters;

    if (types) {
        params.l = params.l || language;
        params.t = types
            .map(type => {
                const borgType = borgTypes[type];
                if (borgType && borgType.code) {
                    return borgType.code;
                }
                return false;
            })
            .filter(item => item)
            .join(',');
    }

    if (params.q) {
        delete params.q;
    }

    return params;
};

const borgProvider = {
    ...providerPrototype,
    ...{
        remoteUrl: '//autocomplete.toolfactory.tech/query?q=%QUERY',
        parameters: {
            f: 'json',
            g: false,
            n: 20,
            o: '',
            p: ''
        },
        group: {
            key: 't'
        },
        dataset: {
            displayValue: 'text',
            displayKey: 'content'
        },
        options: {
            hint: false,
            highlight: true,
            minLength: 3
        },
        suggestions: {
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            initialize: false
        },
        propertiesToSelect: {
            value: 'value',
            content: 'content',
            type: 'type',
            latlon: 'latlon'
        },
        configure: function fn(autocompleteInstance, lang, autocomplete = {}) {
            const datasets = [];
            const literals = { ...autocompleteLiterals(lang), ...autocomplete };

            if (this.remoteUrl) {
                this.dataset.limit = this.limit || this.dataset.limit;
                this.parameters = configureParameters(lang, this.parameters, this.types);

                const url = this.generateUrl(this.remoteUrl, this.parameters);

                if (this.group && this.group.key && this.types && this.types.length > 0) {
                    this.types.forEach(groupKey => {
                        const borgType = borgTypes[groupKey];

                        if (borgType && borgType.code) {
                            const icon = this.getIconByClassName(autocompleteInstance, borgType.icon);
                            datasets.push({
                                ...this.dataset,
                                source: new Bloodhound({
                                    ...this.suggestions,
                                    remote: {
                                        url,
                                        wildcard: '%QUERY',
                                        transform: response => {
                                            const type = borgType.code;
                                            return transform(response, this.dataset, type);
                                        }
                                    }
                                }),
                                templates: {
                                    header: `<span>${icon}${(literals[borgType.literal] || '').toUpperCase()}</span>`
                                }
                            });
                        }
                    });
                }

                if (datasets.length === 0) {
                    datasets.push({
                        ...this.dataset,
                        source: new Bloodhound({
                            ...this.suggestions,
                            remote: {
                                url,
                                wildcard: '%QUERY',
                                transform: response => transform(response, this.dataset)
                            }
                        })
                    });
                }
            }

            return datasets;
        },
        transform: function fn(itemToProcess) {
            const item = itemToProcess;

            if (item.value) {
                const values = item.value.split('_');

                if (values.length === 2) {
                    [item.type, item.value] = values;
                }
            }

            return item;
        }
    }
};

module.exports = borgProvider;
